import script from "./MicrochipInputView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MicrochipInputView.vue?vue&type=script&setup=true&lang=ts"

import "./MicrochipInputView.vue?vue&type=style&index=0&id=1b35af3c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src839921157/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b35af3c"]])

export default __exports__